import { render, staticRenderFns } from "./ButtonBMPSave.vue?vue&type=template&id=bce55a78"
import script from "./ButtonBMPSave.vue?vue&type=script&lang=js"
export * from "./ButtonBMPSave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports